import type {
  AdminTenantMonthCost,
  TenantUsageBreakdown,
  UsageByType,
  UsageMonthPoint,
} from "@repo/shared/types";
import { get } from "@/lib/api/_client";

const API_BASE = process.env.BUN_PUBLIC_API_URL;

/** A tenant admin's own metered usage (settings page). */
export const tenantUsage = {
  monthly: () => get<UsageMonthPoint[]>("/internal/tenant/usage/monthly"),
  breakdown: (month: string) =>
    get<TenantUsageBreakdown>(
      `/internal/tenant/usage/breakdown?month=${encodeURIComponent(month)}`,
    ),
};

/** Cross-tenant metered usage (admin page) — server scopes by partner ownership. */
export const adminUsage = {
  monthly: () => get<UsageMonthPoint[]>("/internal/admin/usage/monthly"),
  byTenant: (month: string) =>
    get<AdminTenantMonthCost[]>(
      `/internal/admin/usage/by-tenant?month=${encodeURIComponent(month)}`,
    ),
  tenantBreakdown: (tenantId: string, month: string) =>
    get<UsageByType[]>(
      `/internal/admin/usage/tenant-breakdown?tenantId=${encodeURIComponent(tenantId)}&month=${encodeURIComponent(month)}`,
    ),
  exportPdf: (tenantId: string, month: string) => {
    const url = `${API_BASE}/internal/admin/usage/export?tenantId=${encodeURIComponent(tenantId)}&month=${encodeURIComponent(month)}`;
    window.open(url, "_blank");
  },
};
